import { getPublicSettings } from "./api-client";

/**
 * Porté depuis apps/web/lib/contact.ts (pas de dépendance Next.js dans
 * l'original — seul l'import de `getPublicSettings` change de chemin).
 */
export interface WhatsAppContact {
  /** Numéro formaté pour l'affichage, ex. "+225 05 04 59 45 20". */
  display: string;
  /** Lien wa.me (chiffres uniquement, sans "+" ni espaces). */
  link: string;
}

const FALLBACK_DISPLAY = "[numéro indisponible]";

/**
 * Lit `support.whatsapp` en base (`setting`, `isPublic = true`) plutôt que de
 * coder le numéro en dur : modifiable depuis la base sans redéploiement.
 *
 * Si l'API est indisponible ou le paramètre absent, repli explicite et
 * visiblement un placeholder — jamais un faux numéro qui aurait l'air réel.
 */
export async function getWhatsAppContact(): Promise<WhatsAppContact> {
  try {
    const settings = await getPublicSettings();
    const raw = settings["support.whatsapp"];

    if (typeof raw === "string" && raw.trim().length > 0) {
      const digitsOnly = raw.replace(/[^0-9]/g, "");
      return { display: raw, link: `https://wa.me/${digitsOnly}` };
    }
  } catch {
    // apps/api indisponible : repli ci-dessous, pas de page cassée.
  }

  return { display: FALLBACK_DISPLAY, link: "#" };
}
